import { withTranslation } from 'react-i18next';

import Button from '@components/Common/Button';

import style from './style.module.css';

const QuitWindow = ({ t, handleCancel = () => {}, handleConfirm = () => {} }) => {
    return (
        <div className={style.root}>
            <p>{t('Are you sure you want to quit the capture app ?')}</p>
            <div className={style.buttonContainer}>
                <Button theme="SECONDARY" onClick={handleCancel}>
                    {t('Cancel')}
                </Button>
                <Button theme="PRIMARY" onClick={handleConfirm}>
                    {t('Confirm')}
                </Button>
            </div>
        </div>
    )
};

export default withTranslation()(QuitWindow);